import * as _ from 'lodash-es';
import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { UserRole } from '../enums/user-role.enum';
import { IUserClaims } from '../models/user-claims';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  public constructor(
    private readonly authenticationService: AuthenticationService) { }

  public isInRole(role: string): boolean {
    const claims = this.authenticationService.getUserClaims();

    return this.containsRole(role, claims);
  }

  public hasAnyRole(roles: string[]): boolean {
    const claims = this.authenticationService.getUserClaims();

    return claims && claims.roles && _.intersection(claims.roles, roles).length > 0;
  }

  public hasOnlyRole(role: UserRole): boolean {
    const claims = this.authenticationService.getUserClaims();
    return this.containsRole(role, claims) && claims.roles.length == 1;
  }

  private containsRole(role: string, claims: IUserClaims): boolean {
    return claims && claims.roles && _.indexOf(claims.roles, role) >= 0;
  }
}
